<template>
    <div class="container">
        <el-row>
            <el-col :span="2">
                <cma-catalog :site-type="this.site_type" :project-id="this.project_id" :site-id="this.site_id"
                             :rr-type="this.rr_type" :route-name="'site_'+this.site_type+'_list'"></cma-catalog>
            </el-col>
            <el-col :span="22">
                <p style="font-size: 22px;text-align: center">工程概况</p>
                <table>
                    <tr>
                        <td>项目名称</td>
                        <td colspan="5">{{ form.project_name }}</td>
                    </tr>
                    <tr>
                        <td>项目地址</td>
                        <td colspan="5">{{ form.site_address }}</td>
                    </tr>
                    <tr>
                        <td>委托单位</td>
                        <td colspan="5">{{ form.client_name }}</td>
                    </tr>
                    <tr>
                        <td>联系人</td>
                        <td colspan="2">{{ form.client_leader }}</td>
                        <td>联系电话</td>
                        <td colspan="2">{{ form.phone }}</td>
                    </tr>
                    <tr>
                        <td>建筑面积（m²）</td>
                        <td colspan="2">{{ form.builder_area }}</td>
                        <td>受检面积（m²）</td>
                        <td colspan="2">{{ form.detect_area }}</td>
                    </tr>
                    <tr>
                        <td>建筑楼层数</td>
                        <td colspan="2">{{ form.builder_floor }}</td>
                        <td>检测部位</td>
                        <td colspan="2">{{ form.detect_part }}</td>
                    </tr>
                    <tr>
                        <td>建筑高度（m）</td>
                        <td colspan="2">{{ form.builder_high }}</td>
                        <td>使用性质</td>
                        <td colspan="2">{{ form.builder_nature }}</td>
                    </tr>
                    <tr>
                        <td>环境温度（℃）</td>
                        <td colspan="2">
                            {{ form.hjwd }}
                        </td>
                        <td>环境湿度（%RH）</td>
                        <td colspan="2">
                            {{ form.hjsd }}
                        </td>
                    </tr>
                    <tr v-if="site_type==='czw'">
                        <td>总户数</td>
                        <td>{{ form.zhs }}</td>
                        <td>已检测户数</td>
                        <td>{{ form.yjchs }}</td>
                        <td>入户率（%）</td>
                        <td>{{ form.rhl }}</td>
                    </tr>
                    <tr v-if="site_type==='czw'">
                        <td>检测房间号</td>
                        <td colspan="5">{{ form.jcfj }}</td>
                    </tr>
                    <tr>
                        <td>检测起讫日期</td>
                        <td colspan="5">
                            {{ form.jcqqsj }}
                        </td>
                    </tr>
                    <tr>
                        <td>主要检测仪器</td>
                        <td colspan="5">
                            <p>红外热成像仪、接地电阻测量仪、钳形接地电阻测试仪、漏电保护开关测试仪、</p>
                            <p>绝缘电阻测试仪、万用表、钳形电流表、数字温湿度计、激光测距仪、数字风速计。</p>
                        </td>
                    </tr>
                    <tr>
                        <td>检测内容</td>
                        <td colspan="5">
                            <el-checkbox-group v-model="form.jcnr">
                                <el-checkbox label="电气系统的带电设备红外诊断" checked></el-checkbox>
                                <el-checkbox v-if="this.site_type!=='sx'" label="电气系统的接地电阻"
                                             checked></el-checkbox>
                                <el-checkbox label="电气系统的剩余电流保护装置" checked></el-checkbox>
                                <el-checkbox v-if="this.site_type ==='other'" label="电气系统的绝缘电阻"
                                             checked></el-checkbox>
                                <el-checkbox label="电气系统的距离" checked></el-checkbox>
                            </el-checkbox-group>
                            <p>备注：具备检测条件并已实施检测项在“□”打“√”，无则打“×”</p>
                        </td>
                    </tr>
                    <tr>
                        <td>检测依据规范标准</td>
                        <td colspan="5">
                            <p>SZDB/Z 139-2015《建筑电气防火检测技术规范》；</p>
                            <p>DBJ/T15-138-2018《建筑电气防火检测技术规程》；</p>
                            <p>DL/T 664-2016《带电设备红外诊断应用规范》。</p>
                        </td>
                    </tr>
                    <tr>
                        <td>检测条件要求</td>
                        <td colspan="5">
                            <p>建筑电气防火检测应在电气设备和线路经过 1h 以上时间的有载运行，进入正常热稳定工作状态，其温度变化率小于
                                1℃/h 后进行。</p>
                        </td>
                    </tr>
                </table>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data() {
        return {
            project_id: '',
            site_id: '',
            site_type: '',
            rr_type: 'report',
            form: {
                id: '',
                project_name: '',
                site_address: '',
                client_name: '',
                client_leader: '',
                phone: '',
                builder_area: '',
                detect_area: '',
                builder_floor: '',
                detect_part: '',
                builder_high: '',
                builder_nature: '',
                hjwd: '',
                hjsd: '',
                jcfj: '',
                jcqqsj: '',
                zyjcyq: '',
                jcnr: [],
                jcyjgfbz: '',
                jctjyq: '',
                rhl: '',
                yjchs: '',
                zhs: '',
            },
        }
    },
    methods: {
        async getRecord() {
            try {
                let params = {
                    project_id: this.project_id,
                    site_id: this.site_id,
                }
                let res = await this.$Api.post('get_record_cma_gcgk', params)
                if (res) {
                    Object.keys(res).forEach(key => {
                        if (this.form.hasOwnProperty(key)) {
                            if (key === 'jcnr') {
                                if (res[key]) {
                                    res[key] = res[key].split(",")
                                } else {
                                    res[key] = []
                                }
                            }
                            this.form[key] = res[key]
                        }
                    })
                }
            } catch (e) {
                this.$message.error(e.errormsg)
            }
        }
    },
    created() {
        this.project_id = this.$route.params.project_id
        this.site_id = this.$route.params.site_id
        this.site_type = this.$route.params.site_type
        this.getRecord();
    }
}
</script>
<style scoped>
table {
    width: 90%;
    margin-left: 60px;
}

table, table tr td {
    border: 1px solid black;
    border-collapse: collapse;
}

table td {
    text-align: center;
    font-size: 22px;
}

table tr td p {
    text-align: left;
    font-size: 16px;
}

.el-checkbox {
    text-align: left;
    display: block;
}
</style>
